import classNames from 'classnames';
import { Skeleton } from './Skeleton';

export interface ChartEmptyStateProps {
  isError?: boolean;
  isLoading?: boolean;
  loadingCount?: number;
  notFoundCount?: number;
  countRow?: number;
}

export const ChartEmptyState = ({
  isError = false,
  isLoading = false,
  loadingCount = 5,
  notFoundCount = 6,
  countRow = 1,
}: ChartEmptyStateProps) => {
  return (
    <span className="relative flex flex-col items-center w-full h-full justify-center gap-10">
      {new Array(isLoading ? loadingCount : notFoundCount).fill(0).map((_, i) => (
        <div
          key={'empty_field_' + (i + 1)}
          className={classNames('w-full flex gap-4 items-center')}
          style={{ opacity: 1 - (i + 1) * 0.15 }}
        >
          {isLoading ? (
            countRow <= 1 ? (
              <Skeleton width={`calc(70% + ${(i + 1) * 5}%)`} />
            ) : (
              <div className="flex gap-8 items-center justify-between w-full">
                {new Array(countRow).fill(0).map((_, row) => (
                  <Skeleton width={`calc(90% - ${(i + 1) * 5}%)`} key={row} />
                ))}
              </div>
            )
          ) : (
            <>
              <span
                style={{ width: `calc(10% + ${(i + 1) * 5}%)` }}
                className="border-4 rounded-lg"
              ></span>
              <span className="flex-auto border-2 rounded-lg border-dashed"></span>
            </>
          )}
        </div>
      ))}

      {!isLoading && (
        <div className="absolute flex items-center justify-center m-auto top-0 left-0 right-0 bottom-0 text-sm leading-[22px] text-[#737373] font-[Inter]">
          {isError ? 'Error loading:(' : 'No data to display'}
        </div>
      )}
    </span>
  );
};
